import React from 'react';
import { Bottom, BottomItem, BottomLabel, BottomValue, MobileWrapper } from '../styles';
import TransactionStatus from '../../../components/transactions/components/TransctionStatus';


interface Props{
    transactionRef: string;
    payoutAmount: string;
    payoutCurrency: string;
    transferFees: string;
    rate: string;
    totalDebit: string;
    beneficiary:string;
    date:string;
    status: string;
}



const MobileCard = ({transactionRef, payoutAmount, transferFees, rate, totalDebit, beneficiary,  date, status }: Props) => {
  return (
    <MobileWrapper>
        <Bottom>
            <BottomItem>
            <BottomLabel> Transaction ref</BottomLabel>
            <BottomValue>{transactionRef}</BottomValue>
            </BottomItem>

            <BottomItem>
            <BottomLabel>Payout Amount</BottomLabel>
            <BottomValue>{payoutAmount}</BottomValue>
            </BottomItem>

            <BottomItem>
            <BottomLabel>Transfer Fees</BottomLabel>
            <BottomValue>{transferFees}</BottomValue>
            </BottomItem>

            <BottomItem>
            <BottomLabel>Rate</BottomLabel>
            <BottomValue>{rate}</BottomValue>
            </BottomItem>

            <BottomItem>
            <BottomLabel>Total Debit</BottomLabel>
            <BottomValue>{totalDebit}</BottomValue>
            </BottomItem>

            <BottomItem>
            <BottomLabel>Beneficiary</BottomLabel>
            <BottomValue>{beneficiary}</BottomValue>
            </BottomItem>

            <BottomItem>
            <BottomLabel>Date</BottomLabel>
            <BottomValue>{date}</BottomValue>
            </BottomItem>

            <BottomItem>
            <BottomLabel>Status</BottomLabel>
            <TransactionStatus text={status} />
            </BottomItem>

        </Bottom>


    </MobileWrapper>
  )
}

export default MobileCard;